import { Box, HStack, Text, Spinner } from '@chakra-ui/react';

/**
 * Loading indicator for chat messages
 * Displays a typing/thinking animation
 */
export default function ChatLoadingIndicator() {
  return (
    <Box display="flex" justifyContent="flex-start">
      <Box
        maxW="85%"
        bg="bg.surface"
        p={3}
        borderRadius="xl"
        boxShadow="sm"
      >
        <Text fontSize="xs" fontWeight="semibold" color="text.primary" mb={1}>
          AI Chef
        </Text>
        <HStack>
          <Spinner size="sm" />
          <Text fontSize="sm" color="text.muted">
            Thinking...
          </Text>
        </HStack>
      </Box>
    </Box>
  );
}
